// src/modals/ClientProjectsModal.jsx
import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ClientProjectsModal = ({ 
  open, 
  onClose, 
  clientName, 
  clientId, 
  projects = [] 
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          bgcolor: 'background.paper',
          color: 'text.primary'
        }
      }}
    >
      <DialogTitle sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        pb: 1
      }}>
        <Typography variant="h6" sx={{ fontSize: '1.1rem', fontWeight: 'bold' }}>
          {clientName} - All Projects
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      
      <DialogContent>
        <Box sx={{ py: 2 }}>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Complete project history and details for {clientName}.
          </Typography>
          
          <Typography variant="body2" color="text.secondary">
            This modal will display a comprehensive list of all projects for this client,
            including detailed project information, timelines, budgets, and team assignments.
          </Typography>
          
          {projects.length > 0 && (
            <Typography variant="body2" sx={{ mt: 2 }}>
              Found {projects.length} projects for this client.
            </Typography>
          )}
        </Box>
      </DialogContent>
      
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ClientProjectsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  clientName: PropTypes.string,
  clientId: PropTypes.string,
  projects: PropTypes.array
};

export default ClientProjectsModal;
